import {HttpClient, HttpParams} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EmailIntegrationPayload, IntegrationResponse, PaginatedIntegrationResponse, SlackIntegrationPayload } from '../../../shared/models/integration-responses';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor() { }

  private httpClient: HttpClient = inject(HttpClient);

  createEmailIntegration(payload: EmailIntegrationPayload): Observable<IntegrationResponse> {
    return this.httpClient.post<IntegrationResponse>(`${environment.baseUri}/email`, payload);
  }

  getAll(page: number, size: number, ): Observable<PaginatedIntegrationResponse>{
    return this.httpClient.get<PaginatedIntegrationResponse>(`${environment.baseUri}/integrations`,{
      params: new HttpParams()
        .set('page', page.toString())
        .set('size', size.toString())
    })
  }

  createSlackIntegration(payload: SlackIntegrationPayload): Observable<any> {
    console.log('sending code to BE');
    return this.httpClient.post<any>(`${environment.baseUri}/app/oauth`, {},{params: {
        code: payload.code,
        redirectUri: payload.redirectUri,
        authType: payload.authType,
      }});
  }

  deleteIntegration(integrationId: number): Observable<any> {
    return this.httpClient.delete(`${environment.baseUri}/integration/${integrationId}/delete`);
  }

  updateAlertIntegration(alertId: number, payload:any){
    return this.httpClient.put<IntegrationResponse>(`${environment.baseUri}/alert-group/${alertId}`, payload);
  }
}
